import {BaseService} from '@services/base.services';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'environments/environment';
import {IPulseType} from '@shared/models/entities';

@Injectable()
export class CommonService extends BaseService {
  constructor(private _htc: HttpClient) {
    super();
  }
  // AllowAnonymous
  getPulseTypeById(
    parentTypeId: number,
    childTypeClassID: number = null,
    includeExtraLongString: boolean = false,
    refreshCache: boolean = false
  ): Observable<IPulseType[]> {
    const param: any = {
      parentTypeId: parentTypeId,
      childTypeClassID: childTypeClassID,
      includeExtraLongString: includeExtraLongString,
      refreshCache: refreshCache
    };
    return this._htc.get(
      `${environment.webApi_NonBreeze}/PulseType_GetActiveByParentTypeID`,
      {
        params: param
      }
    ) as Observable<IPulseType[]>;
  }
  getActiveByTypeClassId(
    typeclassId: number,
    includeExtraLongString: boolean = false,
    refreshCache: boolean = false
  ): Observable<IPulseType[]> {
    const param: any = {
      typeclassId: typeclassId,
      includeExtraLongString: includeExtraLongString,
      refreshCache: refreshCache
    };
    return this._htc.get(
      `${environment.webApi_NonBreeze}/PulseType_GetActiveByTypeClassID`,
      {
        params: param
      }
    ) as Observable<IPulseType[]>;
  }

  getHelpTopic(
    companyID: number = 1,
    helpContentType: number,
    topicName: string
  ): Observable<IPulseType[]> {
    return this._htc.post(
      `${environment.pulse1x_PublicUrl_SPA_API}/GetHelpTopic`,
      {
        companyID: companyID,
        helpContentType: helpContentType,
        topicName: topicName
      },
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json')
      }
    ) as Observable<IPulseType[]>;
  }
}
